import React from 'react';
import { Link } from 'react-router-dom';
import { Code, Smartphone, Wifi, Server, Shield, Monitor, Cpu, Cloud } from 'lucide-react';
import AnimatedSection from '../AnimatedSection/AnimatedSection';
import './PageHeader.css';

export default function PageHeader({ title, breadcrumb, description, buttonText, buttonLink }) {
  const images = [
    'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1600&q=80',
    'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1600&q=80',
  ];

  return (
    <div className="page-header-container">
      <div className="scrolling-wrapper">
        {[...images, ...images].map((img, index) => (
          <img key={index} src={img} alt={`Tech background ${index}`} />
        ))}
      </div>
      
      <div className="header-overlay"></div>

      {/* Floating Animated Icons */}
      <div className="floating-icons-container">
        <Code size={120} className="float-icon icon-1" />
        <Server size={100} className="float-icon icon-2" />
        <Wifi size={140} className="float-icon icon-3" />
        <Shield size={110} className="float-icon icon-4" />
        <Smartphone size={90} className="float-icon icon-5" />
        <Cpu size={130} className="float-icon icon-6" />
        <Cloud size={150} className="float-icon icon-7" />
        <Monitor size={100} className="float-icon icon-8" />
      </div>
      
      <AnimatedSection className="header-content">
        {breadcrumb && <p className="breadcrumb">{breadcrumb}</p>}
        <h1>{title}</h1>
        {description && <p className="description">{description}</p>}
        
        {buttonText && buttonLink && (
          <Link to={buttonLink}>
            <button className="btn-primary">{buttonText}</button>
          </Link>
        )}
      </AnimatedSection>
    </div>
  );
}